// eslint-disable-next-line import/prefer-default-export
export const muiOutlinedInputComponent = {
  styleOverrides: {
    root: () => ({
      padding: 0,
    }),
    notchedOutline: () => ({
      display: 'none',
    }),
  },
};
